import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import imgLogo from './UPPL_RawMaterialsForm_Logo.png';
import rightLogo from './right_bar.jpg';
import SectionC from './Section3Images/SectionC.png';
import SectionD1 from './Section3Images/SectionD1.png';
import SectionE2 from './Section3Images/SectionE2.png';
import SectionE3 from './Section3Images/SectionE3.png';
import SectionE4 from './Section3Images/SectionE4.png';
import SectionF1 from './Section3Images/SectionF1.png';
import Pic1Img from './Section3Images/LabeledBaggedPartSectG.jpg';
import Pic2Img from './Section3Images/LabelSectG.jpg';
import Pic3Img from './Section3Images/CushioningMaterialSectG.png';
import Pic4Img from './Section3Images/OpenBoxWithPartInsideSectG.jpg';
import Pic5Img from './Section3Images/InsertsPadsStrapsOtherSectG.jpg';
import Pic6Img from './Section3Images/ClosedBoxWithLabelSectG.jpg';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import validator from "validator";
import ImageUploadSection from "./ImageUploadSection";

function NewRawMaterialsRequstForm() {
  const auth = useAuth();
  const [configJsonFile, setConfigJsonFile] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
        const data = await response.json();
        setConfigJsonFile(data);
        console.log("Json file read from the Public folder completed:");
      } catch (error) {
        console.error('Error fetching Config JSON file data:', error);
      }
    }
    fetchData();
  }, []);

  const [selectedSectionA_RowID, setSectionA_RowID] = useState("");
  const [OtherComments, setOtherComments] = useState("");
  const [SectionA_Rows, setSectionA_Rows] = useState([
    { id: 1, selected: false, Description: 'Bar Stock' },
    { id: 2, selected: false, Description: 'Blade & Vane Segment' },
    { id: 3, selected: false, Description: 'Casting' },
    { id: 4, selected: false, Description: 'Critical Rotating parts' },
    { id: 5, selected: false, Description: 'Forged Ring & Forging' },
    { id: 6, selected: false, Description: 'Sheet metal' },
    { id: 7, selected: false, Description: 'Tubing' },
    { id: 8, selected: false, Description: 'Other type? (select checkbox and mention below)' },
  ]);


  const handleSectionA_CheckboxChange = (id) => {
    setSectionA_Rows(SectionA_Rows.map(row => ({
      ...row,
      selected: row.id === id // Only the clicked checkbox is selected
    })));
    setSectionA_RowID(id);
  };

  const [SectionB1_RowID, setSectionB1_RowID] = useState("");
  const [SectionB_1_Rows, setSectionB_1_Rows] = useState([
    { id: 1, selected: false, Description: 'Metal straps of 0.625" (16 mm) minimum width by 0.020" (0.51 mm) minimum thickness.' },
    { id: 2, selected: false, Description: 'Green polyester straps of 5/8" (0.625 inches - 16 mm) minimum width by 0.035 inches (0.89 mm) minimum thickness. Breaking strength (lbs) : 1300 lbs (Ref. ASTM D 3950)' }
  ]);

  const handleSectionB_1_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionB_1_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionC_RowID, setSectionC_RowID] = useState("");
  const [SectionC_Rows, setSectionC_Rows] = useState([
    { id: 1, selected: false, Description: 'Yes' },
    { id: 2, selected: false, Description: 'No' },
    { id: 3, selected: false, Description: 'Usage of ISPM 15 Exemptions, entirely made with manufacture wood (plywood)' }
  ]);

  const handleSectionC_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionC_Rows(prevRows =>
      prevRows.map(row => {
        if (id === 1 || id === 2) {
          if (row.id === 1 || row.id === 2) {
            // Force Yes/No to behave as either-or.
            return { ...row, selected: row.id === id ? checked : false };
          }
          return row;
        }

        return row.id === id ? { ...row, selected: checked } : row;
      })
    );
  };

  const [SectionD_RowID, setSectionD_RowID] = useState("");
  const [SectionD_Rows, setSectionD_Rows] = useState([
    { id: 1, selected: false, Description: 'Wooden Crates' },
    { id: 2, selected: false, Description: 'Cardboad box' }
  ]);

  const handleSectionD_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionD_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_1_RowID, setSectionE_1_RowID] = useState("");
  const [SectionE_1_Rows, setSectionE_1_Rows] = useState([
    { id: 1, selected: false, Description: 'Strap on pallet' },
    { id: 2, selected: false, Description: 'Wooden container' },
    { id: 3, selected: false, Description: 'Cardboard sleeve (Reddi crate)' },
    { id: 4, selected: false, Description: 'Bar stock braced' },
    { id: 5, selected: false, Description: 'Each Bar stock layers strapped separately' },
    { id: 6, selected: false, Description: 'Whole package strap on pallet or V-block' }

  ]);

  const handleSectionE_1_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_1_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_2_Rows, setSectionE_2_Rows] = useState([
    { id: 1, selected: false, Description: 'Solid cardboard separator used.' },
    { id: 2, selected: false, Description: 'Strong cardboard pads used on top and bottom.' },

  ]);

  const handleSectionE_2_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_2_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };


  const [SectionE_3_Rows, setSectionE_3_Rows] = useState([
    { id: 1, selected: false, Description: 'Cardboard box, max load 55 lb.' },
    { id: 2, selected: false, Description: 'Wooden crate' },

  ]);

  const handleSectionE_3_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_3_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_3b_Rows, setSectionE_3b_Rows] = useState([
    { id: 1, selected: false, Description: 'Oil protection (ASTM D1748)' },
    { id: 2, selected: false, Description: 'Volatile Corrosion Inhibitor (VCI)' },

  ]);

  const handleSectionE_3b_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_3b_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };


  const [SectionE_4_Rows, setSectionE_4_Rows] = useState([
    { id: 1, selected: false, Description: 'Cardboard box, max load 55Lb.' },
    { id: 2, selected: false, Description: 'Wooden crate' },
    { id: 3, selected: false, Description: 'Individually packaged' },
    { id: 4, selected: false, Description: 'Foam in Place (Instapack, acceptable for critical rotating parts only).' }

  ]);

  const handleSectionE_4_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_4_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_5_Rows, setSectionE_5_Rows] = useState([
    { id: 1, selected: false, Description: 'Cardboard box, max load 55 Ib. Min. strength of 1100 AAA (triple wall).' },
    { id: 2, selected: false, Description: 'Wooden crate' },

  ]);

  const handleSectionE_5_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_5_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_5b_Rows, setSectionE_5b_Rows] = useState([
    { id: 1, selected: false, Description: 'Cardboard or plastic corners between strap & part.' },
    { id: 2, selected: false, Description: 'Strapping devices.' },

  ]);

  const handleSectionE_5b_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_5b_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_6_Rows, setSectionE_6_Rows] = useState([
    { id: 1, selected: false, Description: 'Cardboard box, max load 55Ib. Min. strength of 1100 AAA (tripe wall), strongly strapped.' },
    { id: 2, selected: false, Description: 'Pallet at least 24" length  X 24" wide X 0.625" thick.' },
    { id: 3, selected: false, Description: 'Cardboard or plastic pad between sheets.' },
    { id: 4, selected: false, Description: 'Cardboard or plastic corners between strap & sheet metal part' },
    { id: 5, selected: false, Description: 'Strapping devices.' },

  ]);

  const handleSectionE_6_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_6_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [SectionE_7_Rows, setSectionE_7_Rows] = useState([
    { id: 1, selected: false, Description: 'Cardboard sleeve (Reddi crate). Indivdual tubing.' },
    { id: 2, selected: false, Description: 'Hardwood or plywood crate' },
    { id: 3, selected: false, Description: 'Corrosion preventative compound (VCI). Tubing made from material 410 SST.' },
  ]);

  const handleSectionE_7_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_7_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };


  const [SectionF_Rows, setSectionF_Rows] = useState([
    { id: 1, selected: false, Description: 'Ship to PWC / FSL' },
    { id: 2, selected: false, Description: 'Drop shipped' }
  ]);

  const handleSectionF_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionF_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };


  const [SectionG_Rows, setSectionG_Rows] = useState([
    { id: 1, selected: false, Description: 'Air' },
    { id: 2, selected: false, Description: 'Sea' },
    { id: 3, selected: false, Description: 'Truck' }
  ]);

  const handleSectionG_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionG_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [picture1, setPicture1] = useState(null);
  const [picture2, setPicture2] = useState(null);
  const [picture3, setPicture3] = useState(null);
  const [picture4, setPicture4] = useState(null);
  const [picture5, setPicture5] = useState(null);
  const [picture6, setPicture6] = useState(null);

  const handlePictureUpdate_1 = (newPic) => {
    setPicture1(newPic);
  };
  const handlePictureUpdate_2 = (newPic) => {
    setPicture2(newPic);
  };
  const handlePictureUpdate_3 = (newPic) => {
    setPicture3(newPic);
  };
  const handlePictureUpdate_4 = (newPic) => {
    setPicture4(newPic);
  };
  const handlePictureUpdate_5 = (newPic) => {
    setPicture5(newPic);
  };
  const handlePictureUpdate_6 = (newPic) => {
    setPicture6(newPic);
  };

  const validateAccountSpecialistEamil = (e) => {
      const vEmailcc = e.target.value;
      if (validator.isEmail(vEmailcc)) {
        setAccountSpecialistEmail(e.target.value)
        setAccountSpecialistEmailError("");
      } else {
        setAccountSpecialistEmail(e.target.value)
        setAccountSpecialistEmailError("Please Enter valid Email");
      }
    }
  
    const validateQualitySpecialistEmail = (e) => {
      const vEmailcc = e.target.value;
      if (validator.isEmail(vEmailcc)) {
        setQualitySpecialistEmail(e.target.value)
        setQualitySpecialistEmailError("");
      } else {
        setQualitySpecialistEmail(e.target.value)
        setQualitySpecialistEmailError("Please Enter valid Email");
      }
    }

  const navigate = useNavigate();
  const [apimessage, setAPIMessage] = useState('');
  const [modelPopupshow, setmodelPopupshow] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);

  // Vendor Information section fields

  const [VendorCode, setVendorCode] = useState("");
  const [VendorName, setVendorName] = useState("");
  const [VendorEmail, setVendorEmail] = useState("");
  const [PartNumber, setPartNumber] = useState("");
  const [OptionNumber, setOptionNumber] = useState("");
  const [VendorEmailCc, setVendorEmailCc] = useState("");
  const [SupplierComments1, setSupplierComments1] = useState("");

  const [InitiatorEmailAddress, setInitiatorEmailAddress] = useState("");
  const [initiatorEmailError, setInitiatorEmailError] = useState("");
  const [vendorEmailError, setVendorEmailError] = useState("");
  const [vendorEmailErrorcc, setVendorEmailErrorcc] = useState("");

  const [apiErrormessage, setApiErrormessage] = useState("");
  const [invalidVendorCode, setInvalidVendorCode] = useState("");

  const [isConfirmChecked, setIsConfirmChecked] = useState(false);
  const csrfToken = useRef(null);
  const cookieToken = useRef(null);
  const [loading, setLoading] = useState(false);
  const [AccountSpecialistEmailError, setAccountSpecialistEmailError] = useState("");
  const [QualitySpecialistEmailError, setQualitySpecialistEmailError] = useState("");
  const [AccountSpecialistEmail, setAccountSpecialistEmail] = useState("");
  const [QualitySpecialistEmail, setQualitySpecialistEmail] = useState("");



  let storedValue = localStorage.getItem("UPPAPRawMaterialsProcessID");
  let autoIncrementVal = "";
  let newProcessIDNum = "";

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
  }

  // Form submit 
  const handleSubmit = async (event) => {

    //Form Validation all required dropdown values selected   
    const isEmailValid = formEmailValidation();

    const sectionA_isSelected = SectionA_Rows.some(row => row.selected);
    const sectionB1_isSelected = SectionB_1_Rows.some(row => row.selected);
    const sectionC_isSelected = SectionC_Rows.some(row => (row.id === 1 || row.id === 2) && row.selected);
    const sectionD_isSelected = SectionD_Rows.some(row => row.selected);
    const sectionE1_isSelected = SectionE_1_Rows.some(row => row.selected);
    const sectionE2_isSelected = SectionE_2_Rows.some(row => row.selected);
    const sectionE3_isSelected = SectionE_3_Rows.some(row => row.selected);
    const sectionE3b_isSelected = SectionE_3b_Rows.some(row => row.selected);
    const sectionE4_isSelected = SectionE_4_Rows.some(row => row.selected);
    const sectionE5_isSelected = SectionE_5_Rows.some(row => row.selected);
    const sectionE5b_isSelected = SectionE_5b_Rows.some(row => row.selected);
    const sectionE6_isSelected = SectionE_6_Rows.some(row => row.selected);
    const sectionE7_isSelected = SectionE_7_Rows.some(row => row.selected);
    const sectionF_isSelected = SectionF_Rows.some(row => row.selected);
    const sectionG_isSelected = SectionG_Rows.some(row => row.selected);

    if (isEmailValid) {
      if (sectionA_isSelected && sectionB1_isSelected && sectionC_isSelected && sectionD_isSelected && sectionF_isSelected && sectionG_isSelected) {
        if (picture1 != null) {
          const isSubmitConfirm = window.confirm('Are you sure you want to submit this request?');
          if (isSubmitConfirm) {
            event.preventDefault();
            setLoading(true);
            var CurrentYear = getCurrentDateTime();
            if (storedValue == null) {
              storedValue = 1;
            }

            // console.log("Auth User data Token: "+auth.userData.access_token);      
            var resTokenApiVal = auth.userData.access_token;
            // var resTokenApiVal = "";
            // Call API Start
            newProcessIDNum = Number(storedValue) + 1;
            if (storedValue === 1) {
              autoIncrementVal = String(storedValue).padStart(3, 0);
            }
            else {
              autoIncrementVal = String(newProcessIDNum).padStart(3, 0);
            }
            const requestId = selectedFile.length;

            var dictstring = {
              ProcessInfo: {
                domainId: "UPPAPRawMaterials",
                ProcessId: configJsonFile.UPPAPRawMaterialsGuids.NewUPPAPRawMaterialsProcessID,
                NewRequest: true,
                InstanceNumber: "",
                AttachmentID: "Att_" + configJsonFile.NewDPMSProcessId + "_" + CurrentYear + "_" + autoIncrementVal + "_" + requestId,
                PathID: configJsonFile.UPPAPRawMaterialsGuids.PathID,
                workflowID: configJsonFile.UPPAPRawMaterialsGuids.WorkflowGuid,
                businessEntity: configJsonFile.UPPAPRawMaterialsGuids.BusinessEntityGuid,
                dbId: configJsonFile.UPPAPRawMaterialsGuids.dbId,
                formTypeId: configJsonFile.UPPAPRawMaterialsGuids.formTypeId,
                BaseBPSPortalAddress: configJsonFile.BaseBPSPortalAddress,
                WebconClientId: configJsonFile.WebconClientId,
                WebconclientSecret: configJsonFile.WebconclientSecret,
                WebconTokenURL: configJsonFile.WebconTokenURL
              },
              Form: [
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.InitiateUserID, sValue: InitiatorEmailAddress, name: "Initiator Email" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.PartNumber, sValue: PartNumber, name: "Part Number" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.VendorEmail, sValue: VendorEmail, name: "Vendor Email" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.VendorCode, sValue: VendorCode, name: "Vendor Code" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.VendorName, sValue: VendorName, name: "Vendor Name" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.VendorEmail_Cc, sValue: VendorEmailCc, name: "Vendor emailcc" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.OptionNumber, sValue: OptionNumber, name: "Option Number" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.Description, sValue: SupplierComments1, name: "Supplier Comments" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.IsDataFromReact, sValue: "true", name: "IsDataFromReact" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.SectionA_RowNum_Select, sValue: selectedSectionA_RowID.toString(), name: "Section A RowID" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.SectionA_Other_Comment, sValue: OtherComments, name: "Section A Other Comment" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.AccountSpecialistEmail, sValue: AccountSpecialistEmail, name: "Account Specialist email" },
                { GUID: configJsonFile.UPPAPRawMaterialsGuids.QualitySpecialistEmail, sValue: QualitySpecialistEmail, name: "Quality Specialist email" }
              ],
              Section_C_3_RowData: [],
              Section_C_3_RowDataListGuids: {
                SelectGuid: "",
                SectionsItemListGuid: ""
              },
              Section_D_RowData: [],
              Section_D_RowDataListGuids: {
                SelectGuid: "",
                SectionsItemListGuid: ""
              },
              Section_E_2_RowData: [],
              Section_E_2_RowDataListGuids: {
                SelectGuid: "",
                SectionsItemListGuid: ""
              },
              Section_F_RowData: [],
              Section_F_RowDataListGuids: {
                SelectGuid: "",
                SectionsItemListGuid: ""
              },
              Section_D_RowTextData: [],
              Section_D_RowTextDataListGuids: {
                SelectGuid: "",
                SectionsItemListGuid: ""
              },
              Section_E_4_RowData: [],
              Section_E_4_RowDataListGuids: {
                SelectGuid: "",
                SectionsItemListGuid: ""
              },
              Section_B_1_RowData: SectionB_1_Rows,
              Section_B_1_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_B_1_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_B_1_ItemListGuid
              },
              Section_C_RowData: SectionC_Rows,
              Section_C_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_C_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_C_ItemListGuid
              },
              Section_D_RM_RowData: SectionD_Rows,
              Section_D_RM_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_D_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_D_ItemListGuid
              },
              Section_E_1_RowData: SectionE_1_Rows,
              Section_E_1_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_1_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_1_ItemListGuid
              },
              Section_E_2_RM_RowData: SectionE_2_Rows,
              Section_E_2_RM_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_2_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_2_ItemListGuid
              },
              Section_E_3_RowData: SectionE_3_Rows,
              Section_E_3_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_3_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_3_ItemListGuid
              },
              Section_E_3b_RowData: SectionE_3b_Rows,
              Section_E_3b_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_3b_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_3b_ItemListGuid
              },
              Section_E_4_RM_RowData: SectionE_4_Rows,
              Section_E_4_RM_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_4_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_4_ItemListGuid
              },
              Section_E_5_RowData: SectionE_5_Rows,
              Section_E_5_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_5_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_5_ItemListGuid
              },
              Section_E_5b_RowData: SectionE_5b_Rows,
              Section_E_5b_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_5b_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_5b_ItemListGuid
              },
              Section_E_6_RowData: SectionE_6_Rows,
              Section_E_6_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_6_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_6_ItemListGuid
              },
              Section_E_7_RowData: SectionE_7_Rows,
              Section_E_7_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_7_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_E_7_ItemListGuid
              },
              Section_F_RM_RowData: SectionF_Rows,
              Section_F_RM_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_F_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_F_ItemListGuid
              },
              Section_G_RowData: SectionG_Rows,
              Section_G_RowDataListGuids: {
                SelectGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_G_Select_Guid,
                SectionsItemListGuid: configJsonFile.UPPAPRawMaterialsGuids.Section_G_ItemListGuid
              }
            };
            //alert(dictstring);
            var stringifyObj = JSON.stringify(dictstring);
            console.log(dictstring);
            CallWebAPI(stringifyObj, resTokenApiVal);

            // Update Session variable to get increment num
            localStorage.setItem("UPPAPRawMaterialsProcessID", newProcessIDNum);
            // Call API End 
          }
        } else {
          alert("Please make sure in Section H Image 1 photo required....!");
          event.preventDefault();
        }
      }
      else {
        alert("Please make sure at least one checkbox should be selected on each section...!");
        event.preventDefault();
      }
    } else {
      alert("Please fill the all required fields (or) Enter valid email address..!");
      event.preventDefault();
    }

  }

  const formEmailValidation = () => {
    var isFormEmailsValid = false;
    if (validator.isEmail(VendorEmail)) {
      isFormEmailsValid = true;
    }
    return isFormEmailsValid;
  }

  const CallWebAPI = async (requestBody, getTokeVal) => {
    try {
      console.log("UPPAP Raw Materials Attempting to API call to create/update instance..!");
      const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_UPPAP_Url);
      if (!isValidDomain(parsedUrl.hostname)) {
        throw new Error('Invalid domain');
      }
      const axiosInstance = axios.create({
        baseURL: configJsonFile.Server_Webcon_Creation_UPPAP_Url,
        allowAbsoluteUrls: false
      });
      // "https://localhost:7216/WebconCreationUPPAP"
      axios.post(parsedUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal,
          'RequestVerificationToken': csrfToken.current
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          var elementID = res.data;
          var Pic1bolb = base64ToBlob(picture1);
          CallWebAPIUploadSectionGFileToS3(Pic1bolb, 1, getTokeVal, elementID, "RawMaterialImage1.png");
          console.log("After Pic1 upload");
          if (picture2 !== null) {
            var Pic2bolb = base64ToBlob(picture2);
            CallWebAPIUploadSectionGFileToS3(Pic2bolb, 2, getTokeVal, elementID, "RawMaterialImage2.png");
            console.log("After Pic2 upload");
          }
          if (picture3 !== null) {
            var Pic3bolb = base64ToBlob(picture3);
            CallWebAPIUploadSectionGFileToS3(Pic3bolb, 3, getTokeVal, elementID, "RawMaterialImage3.png");
            console.log("After Pic3 upload");
          }
          if (picture4 !== null) {
            var Pic4bolb = base64ToBlob(picture4);
            CallWebAPIUploadSectionGFileToS3(Pic4bolb, 4, getTokeVal, elementID, "RawMaterialImage4.png");
            console.log("After Pic4 upload");
          }
          if (picture5 !== null) {
            var Pic5bolb = base64ToBlob(picture5);
            CallWebAPIUploadSectionGFileToS3(Pic5bolb, 5, getTokeVal, elementID, "RawMaterialImage5.png");
            console.log("After Pic5 upload");
          }
          if (picture6 !== null) {
            var Pic6bolb = base64ToBlob(picture6);
            CallWebAPIUploadSectionGFileToS3(Pic6bolb, 6, getTokeVal, elementID, "RawMaterialImage6.png");
            console.log("After Pic6 upload");
          }
          if (selectedFile.length > 0) {
            for (let i = 0; i < selectedFile.length; i++) {
              // upload each file to S3 calling API here
              let Num = i + 1;
              CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
              console.log("After Attachments " + Num + " upload");
            }
          }
          else {
            setLoading(false);
            setmodelPopupshow(true);
            setApiErrormessage("");
          }
          //setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
          console.log("Status Data:" + res.data);
        }
        setLoading(false);
        setmodelPopupshow(true);
        setApiErrormessage("");
      }).catch(error => {
        if (error.response) {
          console.log('Error response:', error.response.data);
          setLoading(false);
          setApiErrormessage(error.response.data || 'An error occurred');
          if (error.response.data.includes('Vendor Code')) {
            setInvalidVendorCode("Invalid");
            setApiErrormessage("Vendor Code '" + VendorCode + "' does not exist, Please enter correct value and submit again.")
          } else {
            setInvalidVendorCode("");
          };
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      });
      console.log("... Attempt completed!");
    } catch (err) {
      console.log(err);
      console.log("Error Json:" + err.toJSON());
      setAPIMessage("Failed Due to:" + err);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  function base64ToBlob(base64, contentType = 'application/octet-stream') {
    // base64 may come as "data:<mime>;base64,...." — strip the prefix if present
    const parts = base64.split(',');
    const b64 = parts.length > 1 ? parts[1] : parts[0];

    const byteChars = atob(b64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  const CallWebAPIUploadSectionGFileToS3 = async (requestBody, num, getTokeVal, elementID, fileSectionGName) => {
    try {
      let FileNameWithoutSpace = fileSectionGName.replaceAll(" ", "");
      let fileNameVal = elementID + "_" + num + "-" + FileNameWithoutSpace;
      //let fileNameVal = elementID + "_" + num + "-" + requestBody.name;
      console.log("FileName: " + fileNameVal);
      const formData = new FormData();
      formData.append('file', requestBody);
      formData.append('fileName', fileNameVal);
      formData.append('processID', "");
      formData.append('cookie', cookieToken.current);
      // https://localhost:5001/documents
      // configJsonFile.Server_Upload_FilesToS3_APIUrl
      axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
        }
      });

    } catch (err) {
      setLoading(false);
      setApiErrormessage(err.response.data || 'An error occurred');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const CallWebAPIUploadFileToS3 = async (requestBody, num, getTokeVal, elementID) => {
    try {
      let FileNameWithoutSpace = requestBody.name.replaceAll(" ", "");
      let fileNameVal = elementID + "_" + num + "-" + FileNameWithoutSpace;
      console.log("FileName: " + fileNameVal);
      const formData = new FormData();
      formData.append('file', requestBody);
      formData.append('fileName', fileNameVal);
      formData.append('processID', "");
      formData.append('cookie', cookieToken.current);

      axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          //setLoading(false);
          //setmodelPopupshow(true);
          setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
        }
      });

    } catch (err) {
      setLoading(false);
      setApiErrormessage(err.response.data || 'An error occurred');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const isValidDomain = (domain) => {
    const allowedDomains = ['apid.pwc.ca', 'apiq-ext.pwc.ca', 'api-ext.pwc.ca'];
    return allowedDomains.includes(domain);
  };

  const onClickHomeHandler = async (event) => {
    const isConfirmedHome = window.confirm('You might loose the data, Are you sure you want to go to home page?');
    if (isConfirmedHome) {
      navigate('/');
    }
  }
  const onClickCancelHandler = async (event) => {
    const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if (isConfirmedCancel) {
      navigate('/');
    }

  }

  const handleOkButtonModelPopup = () => {
    navigate('/');
    setmodelPopupshow(false);
  }

  const handleChangeConfirmCheckbox = () => {
    setIsConfirmChecked(!isConfirmChecked);
  }

  const validateInitiatorEmail = (e) => {
    const email = e.target.value;
    if (validator.isEmail(email)) {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("");
    } else {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("Please Enter valid Email");
    }
  }
  const validateVendorEmail = (e) => {
    const vEmail = e.target.value;
    if (validator.isEmail(vEmail)) {
      setVendorEmail(e.target.value)
      setVendorEmailError("");
    } else {
      setVendorEmail(e.target.value)
      setVendorEmailError("Please Enter valid Email");
    }
  }
  const validateVendorEmailcc = (e) => {
    const vEmailcc = e.target.value;
    if (validator.isEmail(vEmailcc)) {
      setVendorEmailCc(e.target.value)
      setVendorEmailErrorcc("");
    } else {
      setVendorEmailCc(e.target.value)
      setVendorEmailErrorcc("Please Enter valid Email");
    }
  }


  //auth && auth.userData
  if (auth && auth.userData) {
    return (
      <form onSubmit={handleSubmit}>
        <style>{`
          /* Increase checkbox size for this form only */
          form input[type='checkbox'] {
            width: 22px;
            height: 22px;
            accent-color: #1f2a44;
            vertical-align: middle;
          }
        `}</style>
        <div class="container">
          <div class="row">
            <div class="col-8 p-0">
              <img src={imgLogo} alt="Logo" width="100%" height="80%" />
            </div>
            <div class="col-4 p-0">
              <img src={rightLogo} alt="Logo" width="100%" height="80%" />
            </div>
          </div>
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">VENDOR MANUFACTURING INFORMATION</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div class="row"><label style={{ color: 'red' }}>{apiErrormessage}</label> </div>
            <div class="row">
              <div class="col-2">
                <label for="InitiatorEmailAddress">Initiator User ID<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={InitiatorEmailAddress}
                  onChange={(e) => setInitiatorEmailAddress(e.target.value)}
                  placeholder="Enter Initiator User ID" required />
              </div>
            </div>
            <div class="row">
              <div class="col-2" style={{ width: '17%' }}>
                <label for="PartNumber">Part Number<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4" style={{ width: '33%', paddingLeft: '6px' }}>
                <input type="text"
                  value={PartNumber}
                  onChange={(e) => setPartNumber(e.target.value)}
                  placeholder="Enter Part Number" required />
              </div>
              <div class="col-2">
                <label for="vendorEmail">Vendor Email<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmail}
                  onChange={(e) => validateVendorEmail(e)}
                  placeholder="Enter Vendor email" required />
                <div style={{ color: 'red' }}>{vendorEmailError}</div>
              </div>

            </div>
            <div class="row">
              <div class="col-2">
                <label for="vendorCode">Vendor Code<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="number"
                  value={VendorCode}
                  onChange={(e) => setVendorCode(e.target.value)}
                  placeholder="Enter Vendor code" required style={{ borderColor: invalidVendorCode ? 'red' : '' }} />
              </div>
              <div class="col-2">
                <label for="vendorName">Vendor Name<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorName}
                  onChange={(e) => setVendorName(e.target.value)}
                  placeholder="Enter Vendor Name" required />
              </div>
            </div>


            <div class="row">
              <div class="col-2">
                <label for="OptionNumber">Option Number</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={OptionNumber}
                  onChange={(e) => setOptionNumber(e.target.value)}
                  placeholder="Enter Option Number" />
              </div>
              <div class="col-2">
                <label for="VendorEmailCc">VendorEmail (Cc)</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmailCc}
                  onChange={(e) => validateVendorEmailcc(e)}
                  placeholder="Enter Vendor Email Cc" />
                <div style={{ color: 'red' }}>{vendorEmailErrorcc}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="Account Specialist Email">Account Specialist Email</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={AccountSpecialistEmail}
                  onChange={(e) => validateAccountSpecialistEamil(e)}
                  placeholder="Enter account specialist email" />
                  <div style={{ color: 'red' }}>{AccountSpecialistEmailError}</div>
              </div>
              <div class="col-2">
                <label for="Quality Specialist Email">Quality Specialist Email</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={QualitySpecialistEmail}
                  onChange={(e) => validateQualitySpecialistEmail(e)}
                  placeholder="Enter Quality specialist email" />
                <div style={{ color: 'red' }}>{QualitySpecialistEmailError}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="SupplierComments1">Description</label>
              </div>
              <div class="col-10">
                <textarea class="VendorComments" id="Comments" name="Comments" value={SupplierComments1} placeholder="Enter Supplier Comments" onChange={(e) => setSupplierComments1(e.target.value)} ></textarea>
              </div>
            </div>
          </div>


          <br />
          {/*Section A  */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION A - RAW MATERIAL PART'S FAMILY TYPE</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Packaging requirements of Raw Materials for specific requirements for each raw material type</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionA_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={() => handleSectionA_CheckboxChange(row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
            {/* Show OtherComments only if SectionA row 8 is selected */}
            {SectionA_Rows.find(row => row.id === 8 && row.selected) && (
              <div class="row">
                <div className="col-12">
                  <textarea
                    id="OtherComments"
                    name="OtherComments"
                    value={OtherComments}
                    onChange={e => setOtherComments(e.target.value)}
                    placeholder="Please specify other type details here"
                    style={{ width: '100%', minHeight: '60px' }}
                  />
                </div>
              </div>
            )}
          </div>
          <br />
          {/* Section B*/}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION B - STRAPING (Refer to CPW40 4.3)</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Container, Box, Crate or Paller shipment shall be strapped with:</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionB_1_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionB_1_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>


          {/* Section C */}
          <br />
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION C - PACKAGING INTERNATIONAL (Packaging international wood regulations ISPM No. 15 - Refer to CPW40 Section 4.4)</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>In the case of using woods pallets and / or wood crates, is it in accordance with ISPM No. 15 (IPPC International Standard for Wood Packaging)?</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionC_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionC_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>


          {/* Section D */}
          <br />
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION D - PACKAGING CONTAINER REQUIREMENTS (Refer to CPW40 Section 4.5)</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Container, Box, Crate or Paller shipment shall be strapped with</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionD_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionD_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          <br />
          {/* Section E.1 */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION E - REQUIREMENTS BY FAMILY TYPE (Refer to CPW40 5.1)</h5></div></div>
          <div className="row"><div> <label style={{fontStyle: 'italic', color: 'blue', fontWeight: 'bold'}}>You are required to answer only one of the E sections below (E1 to E7) according to Raw Material selected in Section A. </label></div></div>
          <div className="row"> <div className="col-12"><h5>E.1) Bar Stock (Refer CPW40 5.1.1)</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div>
              <div class="row">
                <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                      <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                      <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SectionE_1_Rows.map(row => (
                      <tr key={row.id}>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                          <input
                            type="checkbox"
                            checked={row.selected}
                            onChange={(e) => handleSectionE_1_CheckboxChange(e, row.id)}
                          />
                        </td>
                        <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>
          </div>
          <br />
          {/* Section E.2 */}
          <div className="row"> <div className="col-12"><h5>E.2) Blade & Vane Segment</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label >Cardboad partition and top & bottom protector to prevent metal to metal contact, Parts cannot go over or under separator. The parts must be snug and not move or rattle in the partition or in the box</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_2_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_2_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          <br />
          {/* Section E.3 */}
          <div className="row"> <div className="col-12"><h5>E.3) Casting (Refer CPW40 5.1.3)
          </h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>a) Parts in box (snug, not moving or rattle, no metal to metal contact between each other). Casting can be packged either in a plywood, hardwood or a secure cardboard Parts cannot go over or under separator. The parts must be snug and not move or rattle in the partition or in the box</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_3_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_3_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          {/* Section E.3 b*/}

          <div class="marginLeft" Id="InitialFields">
            <label> b) Corrosion protection, (e.g. Cast Iron, Low Alloy Steel, Magnesium Alloy, 410 stainless steel). </label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_3b_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_3b_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          <br />
          {/* Section E.4 */}
          <div className="row"> <div className="col-12"><h5>E.4) Critical Rotating Parts
          </h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Critical parts shall be snug so as not to move or rattle and to avoid any direct contact with each other, Applies to Turbine Disc, Integrally Bladed Rotors (IBR), Impeller, etc.</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_4_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_4_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          <br />
          {/* Section E.5 */}
          <div className="row"> <div className="col-12"><h5>E.5) Forged Ring & Forging (Refer CPW40 5.1.5)
          </h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Air shipment must be packed in wooden crate or cardboard, strapped onto a plywood pallet.</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_5_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_5_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          {/* Section E.5 b */}
          <div class="marginLeft" Id="InitialFields">
            <label>Sea or Land shipment must be packed in hardwood or plywood pallets which will secure materials stacks.</label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_5b_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_5b_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>

          {/* Section E.6 */}
          <br />
          <div className="row"> <div className="col-12"><h5>E.6) Sheet Metal (Refer CPW40 5.1.6)
          </h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Pallet shall have a 20 % larger surfce than the metal sheet to allow sufficient protective dunnage around the part. A plastic or paper packaging sheet must be placed between metal sheets.
            </label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_6_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_6_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
          {/* Section E.7 */}
          <br />
          <div className="row"> <div className="col-12"><h5>E.7) Tubing (Refer CPW40 5.1.7)
          </h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Maxmium tubing length to be determined by P&WC Purchase Order Requirement. Hardwood or plywood crates may be used. (Must comply to the restrictions in 4.4 & 4.5 with respect detinations).

            </label>
            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select</th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionE_7_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionE_7_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>

          {/* Section F */}
          <br />
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION F - DESTINATION (Refer to CPW40 Section 5.2)
          </h5></div></div>
          <div class="marginLeft" Id="InitialFields">

            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionF_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionF_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>

          {/* Section G */}
          <br />
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION G - TRANSPORTATION MODE (Refer to CPW40 Section 5.3)</h5></div></div>
          <div class="marginLeft" Id="InitialFields">

            <div class="row">
              <table border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '50px' }}>ID</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle', width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th style={{ textAlign: 'left', verticalAlign: 'middle' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionG_Rows.map(row => (
                    <tr key={row.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{row.id}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={(e) => handleSectionG_CheckboxChange(e, row.id)}
                        />
                      </td>
                      <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>{row.Description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>

          {/* Section H */}
          <br/>
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION H - PHOTOS (Please supply evidence of packaging. Pictures minimum requirements 700 X 400 Pixels)</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div class="row">
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Image1" Picture={""} onPictureChange={handlePictureUpdate_1} isRequired={true} />
              </div>
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Image2" Picture={""} onPictureChange={handlePictureUpdate_2} isRequired={false} />
              </div>
            </div>
            <div class="row">
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Image3" Picture={""} onPictureChange={handlePictureUpdate_3} isRequired={false} />
              </div>
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Image4" Picture={""} onPictureChange={handlePictureUpdate_4} isRequired={false} />
              </div>
            </div>
            <div class="row">
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Image5" Picture={""} onPictureChange={handlePictureUpdate_5} isRequired={false} />
              </div>
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Image6" Picture={""} onPictureChange={handlePictureUpdate_6} isRequired={false} />
              </div>
            </div>
          </div>
          <br/>
          {/* Section 5 - Attachments */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section I - Attachments</h5></div></div>
          <div class="row">
            <div class="col-2">
              <label for="subject">Attachments</label>
            </div>
            <div class="col-10">
              <input type="file" onChange={(e) => setSelectedFile(e.target.files ? e.target.files : null)} multiple />
            </div>
          </div>


          <div class="row">
            <div>
              <input type="checkbox" value={isConfirmChecked} style={{ color: 'red', width: '22px', height: '22px', verticalAlign: 'middle' }} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label style={{ color: 'red' }}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <input type="submit" value="Submit" /> &nbsp;
              <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
              <input type="button" value="Cancel" onClick={onClickCancelHandler} />
            </div>
          </div>
          <div class="row">
            <div class="col-10 text-success">
              <Modal
                show={modelPopupshow}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> UPPAP Packaging, Preservation & Labelling</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p> Your UPPAP Raw Materials approval request has been submitted.</p>
                  <p> You will receive an email with the request information and details for tracking purposes.</p>
                  <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
                  <p> Click <strong><mark>OK</mark></strong> to return to the home page.</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleOkButtonModelPopup}>
                    OK
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={loading}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> Request in-progress, please wait...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Loading....</p>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </form>
    )
  } else {
    return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
  }
}

export default NewRawMaterialsRequstForm;
